export const ValidationMessagesKeys = {
  minlength: (params: any) => ({
    en: `Minimum length is ${params}`,
    ar: `أقل قيمة هي ${params}`,
  }),
  maxlength: (params: any) => ({
    en: `Maximum length is ${params}`,
    ar: `أكبر قيمة هي ${params}`,
  }),
  min: (params: any) => ({
    en: `Minimum number should be ${params}`,
    ar: `أقل رقم يجب ان يكون ${params}`,
  }),
  max: (params: any) => ({
    en: `Maximum number should be ${params}`,
    ar: `أكبر رقم يجب ان يكون ${params}`,
  }),

  validatePhoneNumber: (params: any) => ({
    en: 'The mobile number  is not correct',
    ar: 'رقم الهاتف غير صحيح',
  }),
  required: {
    en: 'This field is required',
    ar: 'هذا الحقل مطلوب',
  },
  email: {
    en: 'The email is incorrect, use correct email example (user@example.com)',
    ar: 'البريد الالكتروني غير صحيح، استخدم بريد صحيح مثال (user@example.com)',
  },
  pattern: {
    en: 'Please enter a valid value',
    ar: 'الرجاء إدخال قيمة صالحة',
  },
  specialCharacter: {
    en: 'Special characters are not allowed. Please enter letters and numbers only.',
    ar: 'غير مسموح باستخدام الرموز الخاصة. الرجاء إدخال حروف وأرقام فقط.',
  },
  invalidPhone: {
    en: 'The mobile number is not correct',
    ar: 'رقم الهاتف غير صحيح',
  },
  invalidEmail: {
    en: 'This email is not correct',
    ar: 'البريد الالكتروني غير صحيح',
  },
  whitespace: {
    en: 'White spaces are not allowed',
    ar: 'لا يسمح بالمسافات',
  },
  password: {
    en: 'Password Must contains numbers, alphabets and special characters',
    ar: 'كلمة السر يجب ان تحتوي علي ارقام وحروف وعلامات خاصة',
  },
  arabicOnly: {
    en: 'Only Arabic letters allowed',
    ar: 'مسموح ققط بالحروف العربية',
  },
  englishOnly: {
    en: 'Only English letters allowed',
    ar: 'مسموح فقط بالحروف الإنجليزية',
  },
  requiredFile: {
    en: 'This file is required',
    ar: 'هذا الملف مطلوب',
  },
  integersOnly: {
    en: 'Only Integers Allowed',
    ar: 'مسموح فقط بالارقام الصحيحة',
  },
  confirmPassword: {
    en: 'Password does not match',
    ar: 'كلمات المرور غير متطابقة',
  },
};

export const enum validationError {
  minlength = 'minlength',
  maxlength = 'maxlength',
  min = 'min',
  max = 'max',
  phoneNumberVaidation = 'validatePhoneNumber',
}
